export const WorkflowRequestDetailsQueryKey = 'workflowRequestDetailsQueryKey';
